import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  InputAdornment,
  TextField
} from '@mui/material';
import React from 'react';
import {SearchableState} from '../../../../state/searchable-state';
import {SupportTicketMultiSelectFilter} from './SupportTicketMultiSelectFilter';

type Props = {
  searchText: string | null
  onSearchText: (value: string) => void
  searchableState: SearchableState;
  extractAvailableValues: (column: string) => string[];
  translateLocal: (key: string) => string;
  translate: (key: string) => string;
};

export const SupportTicketFilterBar = ({
                                         searchableState,
                                         extractAvailableValues,
                                         translateLocal,
                                         translate,
                                         onSearchText, searchText
                                       }: Props) => {
  const translateModule = (module: string) => translate(`support.ticket.module.${module}`);
  const translateStatus = (status: string) => translate(`support.ticket.status.${status}`);
  const translateType = (type: string) => translate(`support.ticket.type.${type}`);
  const translateErrorType = (type: string) => translate(`support.ticket.error_type.${type}`);

  return (
    <Box display="flex" flexDirection="column" gap={2} mb={2}>
      <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
        <SupportTicketMultiSelectFilter
          label={translateLocal('column.type')}
          column="support_ticket.ticket_type"
          searchableState={searchableState}
          options={extractAvailableValues('support_ticket.ticket_type').map((it) => ({
            label: translateType(it),
            value: it,
          }))}
        />

        <SupportTicketMultiSelectFilter
          label={translateLocal('column.error_type')}
          column="support_ticket.error_type"
          searchableState={searchableState}
          options={extractAvailableValues('support_ticket.error_type').map(
            (it) => ({
              label: translateErrorType(it),
              value: it,
            })
          )}
        />
      </Box>

      {/* 🔹 Dotychczasowa linia filtrów */}
      <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
        <SupportTicketMultiSelectFilter
          label={translateLocal('column.organization')}
          column="support_ticket.organization_name"
          searchableState={searchableState}
          options={extractAvailableValues(
            'support_ticket.organization_name'
          ).map((it) => ({
            label: it,
            value: it,
          }))}
        />

        <SupportTicketMultiSelectFilter
          label={translateLocal('column.account')}
          column="support_ticket.account_name"
          searchableState={searchableState}
          options={extractAvailableValues(
            'support_ticket.account_name'
          ).map((it) => ({
            label: it,
            value: it,
          }))}
        />

        <SupportTicketMultiSelectFilter
          label={translateLocal('column.module')}
          column="support_ticket.module"
          searchableState={searchableState}
          options={extractAvailableValues('support_ticket.module').map((it) => ({
            label: translateModule(it),
            value: it,
          }))}
        />

        <SupportTicketMultiSelectFilter
          label={translateLocal('column.status')}
          column="support_ticket.status"
          searchableState={searchableState}
          options={extractAvailableValues('support_ticket.status').map((it) => ({
            label: translateStatus(it),
            value: it,
          }))}
        />

        <Box ml="auto" minWidth={300}>
          <TextField
            size="small"
            fullWidth
            variant="outlined"
            value={searchText || ''}
            onChange={(e) => onSearchText(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
